export enum CommunicationCampaignState {
  DRAFT = 'draft',
  SCHEDULED = 'scheduled',
  SENDING = 'sending',
  SENT = 'sent',
  QUEUED = 'queued',
  FAILED = 'failed',
}
